import bulk from './bulk';
import fill from './fill';
import list from './list';

const stockMid = {
  namespaced: true,
  modules: {
    list,
    bulk,
    fill,
  },
};

export default stockMid;
